export const NEXT_BUTTON = 'next-button';
export const SPINNER = 'spinner';
